export const    BassURl = `https://project.digitalnawab.com/kidsschool/`